import React, { ChangeEvent } from 'react';

import { Icon, IconColorOptions } from '../../Icon';

import './styles.scss';

interface Props {
    id: string;
    checked: boolean;
    text: string;
    hasError?: boolean;
    className?: string;
    icon?: string;
    iconSize?: string;
    iconColor?: IconColorOptions;
    onChange: (checked: boolean, id: string) => void;
    onClick?: () => void;
}

export const ChipCheckbox = ({
    id,
    checked,
    text,
    hasError,
    className = '',
    icon,
    iconSize,
    iconColor,
    onChange,
    onClick,
}: Props) => {
    const changeHandler = (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.checked, e.target.id);
    const clickHandler = (e: React.MouseEvent<HTMLElement>) => {
        if (onClick) {
            e.preventDefault();
            onClick();
        }
    };

    return (
        <div className={`chip-checkbox ${className}`} onClick={clickHandler}>
            <input type='checkbox' id={id} checked={checked} onChange={changeHandler} />
            <label className={`${hasError ? 'has-error' : ''}`} htmlFor={id}>
                {icon && <Icon icon={icon} size={iconSize || '24'} color={iconColor} className='chip-checkbox__icon' />}
                <span className='chip-checkbox__text'>{text}</span>
            </label>
        </div>
    );
};
